import { styled } from '@mui/material';
import { proAccountThemeCoreUI as theme } from '../themes';

export type SkipContentLinkProps = {
  href: string;
  label: string;
};

const StyledALink = styled('a')(() => ({
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  display: 'block',

  '&:focus': {
    padding: theme.spacing(1),
    width: 'auto',
    height: 'auto',
    fontSize: 16,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    textDecoration: 'underline',
    overflow: 'visible',
  },
}));

/**
 * SkipContentLink component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @param {SkipContentLinkProps} props - The props for the SkipContentLink component.
 */

export const SkipContentLink = (props: SkipContentLinkProps) => {
  const { href, label } = props;

  return <StyledALink href={href}>{label}</StyledALink>;
};
